module.exports = __webpack_public_path__ + "static/media/image_32.3f8fe58f.png";